import { createGlobalStyle } from "styled-components"
import { media } from "./styles"

const GlobalStyle = createGlobalStyle`



*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 62.5%;
  margin: 0 auto;
  height:100%;
  max-width: 200rem;
}

body{
  height: 100%;
  position: relative;
  
}

a{
  text-decoration: none;
}

ul {
  list-style: disc;
}

h1, h2, h3, h4, h5, h6{
  line-height: 1.2;
}

.rounded{
  border-radius: 3rem;
  object-fit: cover;

}

:root{

  

    // COLORS
    --color-blue: #3057A2;
    --color-blue-light: #1D65B0;

    --color-green: #52C56F;
    --color-green-dark: #2AA2A1;
    --color-green-light: #64CA41;

    --color-white: #fff;
    --color-black:#000;


    --color-grey-dark: #373737;
    --color-grey: #8C8C8C;

    --color-underline-grey: #E1E1E1;

    --color-text-grey-light:#B6B6B6;
    --color-text-grey-dark:#757575;

    --color-border-grey: #ADADAD;


    // FONTS
    --font-heading: 'DM Serif Display', serif;
    --font-body: 'Montserrat', sans-serif;


    //FONT SIZES

    --font-size-nav-item: 2.4rem;


    --font-size-heading-landing: clamp(10rem, 15vw, 15rem);

    --font-size-headingXL: clamp(7rem, 10vw, 11rem);
    --font-size-headingL: clamp(6.4rem, 10vw, 10rem);
    --font-size-headingM: clamp(4.8rem, 10vw, 7rem);
    --font-size-headingS: clamp(3.5rem, 10vw, 5rem);
    --font-size-headingXS: clamp(3rem, 10vw, 4.5rem);

    --font-size-subheadingL:  clamp(3.2rem, 5vw, 3.8rem);
    --font-size-subheading:  clamp(2.2rem, 5vw, 2.8rem);
    --font-size-subheadingS:  clamp(1.8rem, 5vw, 2.2rem);
    --font-size-subheadingXS:  clamp(1.6rem, 5vw, 2.2rem);


    --font-size-bodyXL: clamp(2rem, 5vw, 2.4rem);
    --font-size-bodyL: clamp(1.8rem, 5vw, 2.2rem);
    --font-size-bodyM: clamp(1.8rem, 5vw, 2rem);
    --font-size-bodyS: clamp(1.6rem, 5vw, 1.8rem);
    --font-size-bodyXS: clamp(1.4rem, 5vw, 1.6rem);

    --font-size-policy-mobile: 1.2rem;

    --font-size-footerlist: 2.4rem;

    --font-size-footer-heading: clamp(6rem, 5vw, 8rem);
    --font-size-newsletter-heading: 4.5rem;


    --font-size-logo: 6rem;
    --font-size-logo-brand: 1.8rem;

    --font-size-button: 2.5rem;
    --font-size-buttonS: 1.6rem;

    //LINE HEIGHTS

    --line-height-body: 1.8;
    --line-height-bodyS: 1.6;

    //GRADIENTS 

    --header-home-gradient: linear-gradient(85.27deg, rgba(48,87,162,1) 10%, rgba(46,113,162,1) 38%, rgba(42,162,161,1) 73%, rgba(93,201,99,1) 96%);

    --header-landing-gradient: linear-gradient(85.27deg, rgba(48,87,162,.6) 10%, rgba(46,113,162,.6) 38%, rgba(42,162,161,.6) 73%, rgba(93,201,99,.6) 96%);

}

//PARTICLES

#tsparticles {
    position: absolute  !important;
    top: 0 !important;
    left: 0 !important;
    bottom: 0 !important;
    right: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    z-index: 0 !important;
}

// SWIPER

.swiper-button-next{

  &:after{

  }
}


.swiper-btn-container{

    ${media.tabland`
   margin: 0 auto;
    width: 100%;
    max-width:100rem;
    padding: 0 5rem;
  `}

  ${media.phonesmall`
  padding: 0 2.5rem;
  `}
}


.wp-block-button__link{
  color: var(--color-white)!important;
}

/* 
.profile-clip{
  clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);
} */

`

export default GlobalStyle
